<script lang="ts">
    import { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";

    import T from "@components/T.svelte";
    import Text from "@components/Typography/Text.svelte";

    export let namespace: RewardsTranslationNamespaces;

    const REWARDS_REFERRAL_STEPS_TRANSLATION_KEYS = [
        "referral_program_copy_link",
        "referral_program_share_link",
        "referral_program_earn_rewards",
    ];
</script>

<ul class="gw-list-reset-default-styles">
    {#each REWARDS_REFERRAL_STEPS_TRANSLATION_KEYS as key, index (index)}
        <li>
            <Text component="p" variant="secondary" size="sm">
                <T {namespace} translationKey={key} />
            </Text>
        </li>
    {/each}
</ul>
